export default __webpack_public_path__ + "static/media/dark.820bf2af.svg";